export const ISideNavItems = [
    { name: 'Dashboard', icon: 'icons-kpi-dashboard/analysis.png' },
    { name: 'Bookings', icon: 'icons-kpi-dashboard/booking_icon.png' },
    { name: 'Reviews', icon: 'icons-kpi-dashboard/reviews_icon.png' },
    // {
    //     name: 'Blog', icon: '', submenu: [
    //         { name: 'Reviews', icon: 'icons-kpi-dashboard/reviews_icon.png' },
    //         { name: 'Bookings', icon: 'icons-kpi-dashboard/booking_icon.png' },
    //         { name: 'Dashboard', icon: 'icons-kpi-dashboard/dashboard_icon.png' },

    //     ]
    // }
]